import ChatManager from "../Components/ChatManager/ChatManager";
import NavbarD from "../Components/ChatManager/DashBoard";
import FooterManager from "../Components/ChatManager/FooterManager";
import socket from "../utilities/socketIo";
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';




const ChatsRoom = () => {

let {id} = useParams();

 return (
  <>
  <div>

 <NavbarD socket={socket} id={id}/> 


  <ChatManager socket={socket} id={id}/> 
  </div>
  <br />
  <br />
  <br />
   <FooterManager/> 

  </>
 )
};

export default ChatsRoom;
